import React from "react";
import { useHistory } from "react-router";
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import {
  generatePath,
} from "../../utilities/RedirectUtils";
import { Button, Grid, Headline, Type, Utility } from 'mesh-component-library';
import { useScreenBreakpoint } from "../../hooks/useScreenBreakpoint";


const LetsGetStarted = () => {
  const getTranslatedText = useLocale();
  const history = useHistory();
  const screenBreakpoint = useScreenBreakpoint();

  const handleOnClickContinue = () => {
      history.push(generatePath('triage'));
  };

  return (
    <>
      <Grid verticalAlign="middle" id="lets-get-started-page">
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
              vrTop: "sm",
              vrBottom: "sm",
            }}
          >
            <Headline
              title={
                <Type
                  variant="darker"
                  align="left"
                  size={screenBreakpoint === "sm" ? "8xl" : "3xl"}
                  weight="semibold"
                >
                  {getTranslatedText(TRANSLATION_CONSTANTS.LETS_GET_STARTED_TITLE)}
                </Type>
              }
            />
          </Utility.Div>
        </Grid.Column>
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
              vrBottom: "md",
            }}
          >
            <Type align="left">
              {getTranslatedText(TRANSLATION_CONSTANTS.HAVING_TROUBLE_WITH_RENTAL_CAR)}
            </Type>
          </Utility.Div>
        </Grid.Column>
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
            }}
          >
            <Type align="left" weight="bold" style={{fontSize: '16px'}}>
              {getTranslatedText(TRANSLATION_CONSTANTS.WHAT_TO_EXPECT)}
            </Type>
          </Utility.Div>
        </Grid.Column>
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
            }}
          >
            <Type align="left">
              <span className="step-item">
                <span className="step-indicator">1</span>
                <span>{getTranslatedText(TRANSLATION_CONSTANTS.WE_WILL_ASK_FEW_QUESTIONS)}</span>
              </span>
            </Type>
          </Utility.Div>
        </Grid.Column>
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
            }}
          >
            <Type align="left">
              <span className="step-item">
                <span className="step-indicator">2</span>
                <span>{getTranslatedText(TRANSLATION_CONSTANTS.WE_WILL_ASK_TO_SHARE_LOCATION)}</span>
              </span>
            </Type>
          </Utility.Div>
        </Grid.Column>
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
            }}
          >
            <Type align="left">
              <span className="step-item">
                <span className="step-indicator">3</span>
                <span>{getTranslatedText(TRANSLATION_CONSTANTS.A_REPRESENTATIVE_WILL_HELP_YOU)}</span>
              </span>
            </Type>
          </Utility.Div>
        </Grid.Column>
        <Grid.Column
          col={{ sm: 12, md: 4, lg: 4, xl: 4 }}
          offset={{ md: 4, lg: 4, xl: 4 }}
          className="lets-get-started-button"
        >
          <Utility.Div
            utils={{
              hrLeft: "md",
              hrRight: "md",
            }}
          >
            <Button
              hasUpgrade
              shape="pill"
              size="lg"
              onClick={handleOnClickContinue}
              isBlock
            >
              {getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE)}
            </Button>
          </Utility.Div>
        </Grid.Column>
      </Grid>

    </>
  );
};

export default LetsGetStarted;
